angular.module('elogbooksFilters').filter('dashToUnderscore', function(lodash) {
    return function(input) {
        return lodash.snakeCase(input)
    }
});
